import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63eb2bb4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "childExhibitions"
};
const _hoisted_2 = {
  class: "exhibition-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "exhibition-box exhibition-container"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_7 = {
  class: "exhibition-box exhibition-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_childExhibitionItem = _resolveComponent("childExhibitionItem");
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.detail.images
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.language ? $data.detail.en_name : $data.detail.exhibName), 1)]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_childExhibitionItem, {
    childExhibitions: $data.childExhibitions,
    formData: $data.formData,
    language: $data.language
  }, null, 8, ["childExhibitions", "formData", "language"])]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 0
  })) : _createCommentVNode("", true)]);
}